/**
 * Documents utils behavior for ERP Accelerator.
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Handles cn behavior.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
